import AccessTimeIcon from '@mui/icons-material/AccessTime'
import BuildIcon from '@mui/icons-material/Build'
import DescriptionIcon from '@mui/icons-material/Description'
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk'
import SearchIcon from '@mui/icons-material/Search'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SpeedIcon from '@mui/icons-material/Speed'
import ChatIcon from '@mui/icons-material/Chat'
import PsychologyIcon from '@mui/icons-material/Psychology'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'

function LandingProcessComparison () {
  return (
    <section className='lp-process-comparison-section'>
      <div className='lp-section-content'>
        <h2 className='lp-section-title'>
          So läuft es heute vs. mit Engineers Knowledge Base
        </h2>
        <p className='lp-section-subtitle'>
          Ein konkreter Vergleich: Fehlercode E42 beim Lasergerät
        </p>

        <div className='lp-process-comparison'>
          {/* Without Tool */}
          <div className='lp-process-column lp-process-old'>
            <div className='lp-process-header'>
              <div className='lp-process-badge lp-process-badge-old'>Ohne Tool</div>
              <div className='lp-process-time lp-process-time-old'>
                <AccessTimeIcon sx={{ fontSize: 20 }} />
                <span>~2 Stunden</span>
              </div>
            </div>

            <div className='lp-process-steps'>
              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-old'>1</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-old'>
                    <BuildIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Problem erkannt</h3>
                  <p>Lasergerät zeigt Fehlercode E42</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-old'>2</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-old'>
                    <DescriptionIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Manuelle Suche</h3>
                  <p>30+ Minuten in PDF-Manuals blättern</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-old'>3</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-old'>
                    <PhoneInTalkIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Kollegen anrufen</h3>
                  <p>5-10 Anrufe, niemand erreichbar oder beschäftigt</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-old'>4</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-old'>
                    <SearchIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Weiteres Suchen</h3>
                  <p>Online-Foren, alte E-Mails durchsuchen</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step lp-process-step-result'>
                <div className='lp-step-number lp-step-number-old'>5</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-old'>
                    <HourglassEmptyIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Lösung gefunden</h3>
                  <p>Nach 2 Stunden: Kühlsystem prüfen</p>
                  <div className='lp-step-note'>
                    <TrendingDownIcon sx={{ fontSize: 16 }} />
                    <span>Kunde wartet, Gerät steht still</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className='lp-process-divider'>
            <div className='lp-divider-line'></div>
            <div className='lp-divider-vs'>VS</div>
            <div className='lp-divider-line'></div>
          </div>

          {/* With Tool */}
          <div className='lp-process-column lp-process-new'>
            <div className='lp-process-header'>
              <div className='lp-process-badge lp-process-badge-new'>Mit Tool</div>
              <div className='lp-process-time lp-process-time-new'>
                <SpeedIcon sx={{ fontSize: 20 }} />
                <span>~2 Minuten</span>
              </div>
            </div>

            <div className='lp-process-steps'>
              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-new'>1</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-new'>
                    <BuildIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Problem erkannt</h3>
                  <p>Lasergerät zeigt Fehlercode E42</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-new'>2</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-new'>
                    <ChatIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>KI-Suche nutzen</h3>
                  <p>Einfache Frage: "Fehlercode E42 Laser" eingeben</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-new'>3</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-new'>
                    <PsychologyIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Sofortige Antwort</h3>
                  <p>KI findet relevante Lösung aus Wissensdatenbank</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step'>
                <div className='lp-step-number lp-step-number-new'>4</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-new'>
                    <MenuBookIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Detaillierte Anleitung</h3>
                  <p>Schritt-für-Schritt-Anleitung mit Bildern</p>
                </div>
              </div>

              <div className='lp-process-arrow'>
                <ArrowForwardIcon sx={{ fontSize: 24 }} />
              </div>

              <div className='lp-process-step lp-process-step-result'>
                <div className='lp-step-number lp-step-number-new'>5</div>
                <div className='lp-step-content'>
                  <div className='lp-step-icon lp-step-icon-new'>
                    <CheckCircleIcon sx={{ fontSize: 32 }} />
                  </div>
                  <h3>Problem gelöst</h3>
                  <p>Nach 2 Minuten: Kühlsystem geprüft, Durchfluss korrigiert</p>
                  <div className='lp-step-note lp-step-note-success'>
                    <TrendingUpIcon sx={{ fontSize: 16 }} />
                    <span>Kunde zufrieden, Gerät läuft wieder</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='lp-process-comparison-summary'>
          <div className='lp-summary-stat'>
            <div className='lp-summary-number'>60x</div>
            <div className='lp-summary-label'>schneller</div>
          </div>
          <div className='lp-summary-stat'>
            <div className='lp-summary-number'>98%</div>
            <div className='lp-summary-label'>Zeitersparnis</div>
          </div>
          <div className='lp-summary-stat'>
            <div className='lp-summary-number'>0</div>
            <div className='lp-summary-label'>Anrufe nötig</div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingProcessComparison

